import React, { FC } from 'react';

const EmployeeIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.2 163.52H65.9598C49.6398 163.52 36.3198 150.24 36.3198 133.88V65.68C36.3198 49.36 49.5998 36.04 65.9598 36.04H134.2C150.52 36.04 163.84 49.32 163.84 65.68V133.92C163.84 150.24 150.56 163.52 134.2 163.52Z"
        fill="#EFF2F4"
      />
      <path
        d="M88.3999 162.2L98.0399 177.68C98.9999 179.24 101.24 179.24 102.24 177.76L113.28 161.16"
        fill="#EFF2F4"
      />
      <path
        d="M132.749 132.156C150.791 114.114 150.791 84.862 132.749 66.82C114.707 48.7779 85.4552 48.7779 67.4131 66.82C49.3711 84.862 49.3711 114.114 67.4131 132.156C85.4552 150.198 114.707 150.198 132.749 132.156Z"
        fill="#F7C6CC"
      />
      <path
        d="M100.08 140C122.459 140 140.6 121.859 140.6 99.4801C140.6 77.1015 122.459 58.9601 100.08 58.9601C77.7015 58.9601 59.5601 77.1015 59.5601 99.4801C59.5601 121.859 77.7015 140 100.08 140Z"
        fill="#FF2B85"
      />
      <path
        d="M100.08 105.12C106.774 105.12 112.2 99.6938 112.2 93.0001C112.2 86.3064 106.774 80.8801 100.08 80.8801C93.3863 80.8801 87.96 86.3064 87.96 93.0001C87.96 99.6938 93.3863 105.12 100.08 105.12Z"
        fill="white"
      />
      <path
        d="M100.08 108.6C86.8 108.6 75.88 118.68 74.52 131.6C81.48 137.28 90.4 140.68 100.08 140.68C109.76 140.68 118.68 137.28 125.64 131.6C124.32 118.68 113.36 108.6 100.08 108.6Z"
        fill="white"
      />
      <path
        d="M117.12 129C117.12 119.68 124.68 112.12 134 112.12C143.32 112.12 150.88 119.68 150.88 129C150.88 138.32 143.32 145.88 134 145.88C124.68 145.88 117.12 138.32 117.12 129Z"
        fill="#231F20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.229 128.92C124.229 127.964 125.004 127.189 125.96 127.189H141.68C142.636 127.189 143.41 127.964 143.41 128.92C143.41 129.876 142.636 130.65 141.68 130.65H125.96C125.004 130.65 124.229 129.876 124.229 128.92Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.84 119.509C134.796 119.509 135.57 120.284 135.57 121.24V137C135.57 137.956 134.796 138.73 133.84 138.73C132.884 138.73 132.109 137.956 132.109 137V121.24C132.109 120.284 132.884 119.509 133.84 119.509Z"
        fill="white"
      />
    </svg>
  );
};

export default EmployeeIcon;
